<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoadingList"
    :is-show-search-input="true"
    :push-list="RouteConfig.courseWhitelistManage.push"
    search-placeholder="输入姓名、手机号或会员卡号"
  >
    <div
      class="flex"
      slot="header-item-first"
    >
      <div class="flex-center table-filter-item">
        <span class="label-box flex-center">白名单名称：</span>
        <el-input
          v-model="post.course_whitelist_name"
          class="course-whitelist-name"
          maxlength="16"
          show-word-limit
          clearable
          placeholder="请输入 1 ~ 16 位字符的白名单名称"
          @focus="handleNameFocus"
          @blur="handleNameSubmit"
          :disabled="isSaving"
          size="small"
        />
      </div>

      <div class="flex-center table-filter-item">
        <v-select-student
          v-model="student_ids"
          class="student-input"
          :multiple="true"
          :clearable="true"
          :check-course-whitelist-id="id"
          size="small"
          :list="students"
          @listChange="handleStudentsChange"
        />
        <el-button
          class="student-submit-button"
          type="primary"
          @click="handleStudentSubmit"
          size="small"
          :loading="isSaving"
        >添加至本名单</el-button>
      </div>
    </div>
    <v-column-time/>
    <el-table-column label="学员 ID" prop="id"/>
    <v-column-student label="学员"/>
    <el-table-column label="手机号" prop="phone"/>
    <el-table-column label="会员卡号" prop="card_number"/>
    <el-table-column label="身份证号" prop="id_number"/>

    <el-table-column label="操作" width="300">
      <template v-slot="{ row }">
        <v-list-button
          name="移出"
          icon="bin"
          @click="handleDelete(row.id)"
          :is-loading="isDeleting[row.id]"
          message="学员移出本名单后，将无法预约对应的白名单课程，确认要继续操作吗？"
        />
      </template>
    </el-table-column>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`course-whitelist-manage-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>学员 ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>学员</span>
              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="v.id"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>手机号</span>
              <span>{{ v.phone }}</span>
            </div>
            <div class="list-item-detail">
              <span>会员卡号</span>
              <span>{{ v.card_number }}</span>
            </div>
            <div class="list-item-detail">
              <span>身份证号</span>
              <span>{{ v.id_number }}</span>
            </div>
            <div class="list-item-button">
              <v-list-button
                name="移出"
                icon="bin"
                @click="handleDelete(v.id)"
                :is-loading="isDeleting[v.id]"
                message="学员移出本名单后，将无法预约对应的白名单课程，确认要继续操作吗？"
              />
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoadingList" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import {
  show,
  getStudents,
  update,
  storeStudents,
  delStudents
} from '@/api/course-whitelist';
import { getLegalQueryList } from "@/utils/formats";

export default {
  name: RouteConfig.courseWhitelistManage.name,
  data: () => ({
    RouteConfig,
    count: 0,
    list: [],
    students: [],
    lastName: '',
    post: {
      course_whitelist_name: '',
      update_time: 0,
    },
    student_ids: [],
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
    isSaving: false,
    isLoading: false,
    isLoadingList: false,
    isSavingStudents: false,
    isDeleting: {},
    isGetting: {},
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
    id() {
      return +this.$route.params.id || 0;
    },
  },
  watch: {
    '$route'(to) {
      this.show();
      this.load(to);
    },
  },
  beforeMount() {
    this.show();
    this.load();
  },
  methods: {
    handleNameFocus() {
      this.lastName = this.post.course_whitelist_name;
    },
    handleStudentsChange(students) {
      this.students = students;
    },
    async handleNameSubmit() {
      if (this.lastName === this.post.course_whitelist_name) return;
      if (!this.post.course_whitelist_name) {
        this.post.course_whitelist_name = this.lastName;
        this.$message.error('请输入白名单名称');
        return;
      }

      const post = { ...this.post };
      this.isSaving = true;
      const { isError } = await update(this.id, post);
      this.isSaving = false;
      if (isError) return;

      this.$message.success('名称已修改');
    },
    async handleStudentSubmit() {
      if (this.isSavingStudents) return;

      const { student_ids } = this;
      if (!student_ids.length) return this.$message.error('请输入选择学员');

      this.isSavingStudents = true;
      const { isError } = await storeStudents(
        this.id,
        {
          student_ids,
          update_time: this.post.update_time,
        },
      );
      this.isSavingStudents = false;
      if (isError) return;

      this.queryList.page = 1;
      const students = [ ...this.students ];
      students.forEach(item => {
        if (student_ids.includes(item.id)) item.is_disabled = true;
      });
      this.student_ids = [];
      this.students = students;

      RouteConfig.courseWhitelistManage.push({ page: 1, size: this.queryList.size, refresh: Date.now() });
    },
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      const { post } = this;
      const newPost = {};
      Object.keys(data).forEach(key => {
        if (key in post) newPost[key] = data[key];
      });
      Object.assign(post, newPost);
    },
    async load(route = this.$route) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoadingList = true;
      const { isError, data } = await getStudents(this.id, queryList);
      this.isLoadingList = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
    },
    async handleDelete(id) {
      if (!id) return this.$message.warning('缺少学员 ID，无法移出，请刷新页面重新尝试！');
      if (!this.id) return this.$message.warning('缺少白名单 ID，无法移出，请刷新页面重新尝试！');
      if (this.isDeleting[id]) return;

      this.$set(this.isDeleting, id, true);
      const { isError } = await delStudents(this.id, { student_ids: [id], update_time: this.post.update_time });
      this.$set(this.isDeleting, id, false);

      if (!isError) RouteConfig.courseWhitelistManage.push({ page: this.queryList.page, size: this.queryList.size, refresh: Date.now() });
    },
  },
};
</script>

<style src="./manage.css" scoped/>
